import { SESSION } from 'constants/store.constants';

export const selectSession = (state) => state[SESSION];
export const selectSessionToken = (state) => selectSession(state).token.accessToken;
export const selectSessionUser = (state) => selectSession(state).user;
